module.exports = __webpack_public_path__ + "img/searchblockbtn.1a13c892.svg";